<template lang="pug">
  selection-base(
    :value="value"
    :items="items"
    item-value="uuid"
    item-text="closed_at"
    :placeholder="$t('placeholder.select-rond-date-power-ball')"
    @input="$emit('input', $event)"
  )
    template(#selection="{ item }")
      | {{ $t('rounded-is') }} {{ item['closed_at'] | date }}

    template(#item="{ item }")
      | {{ item['closed_at'] | date  }}
      
</template>
<script>
import SelectionBase from './SelectionBase.vue'
import { powerBall as apiPowerball } from '@/apis'

export default {
  components: {
    SelectionBase
  },
  props: {
    value: {
      type: [String,Object],
      default: null
    },
    curItemRoomHistory: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    items: []
  }),
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      const [err, data] = await apiPowerball.roomHistory.gets()
      if(err) return
      this.items = [...data]
      this.$emit('input', data[0].uuid)
    }
  }
}
</script>